export enum Integrations {
  GET_INTEGRATION_APPS_REQUEST = '@integrations/GET_INTEGRATION_APPS_REQUEST',
  GET_INTEGRATION_APPS_SUCCESS = '@integrations/GET_INTEGRATION_APPS_SUCCESS',
  GET_INTEGRATION_APPS_FAIL = '@integrations/GET_INTEGRATION_APPS_FAIL',

  LIST_SITE_INTEGRATIONS_REQUEST = '@integrations/LIST_SITE_INTEGRATIONS_REQUEST',
  LIST_SITE_INTEGRATIONS_SUCCESS = '@integrations/LIST_SITE_INTEGRATIONS_SUCCESS',
  LIST_SITE_INTEGRATIONS_FAIL = '@integrations/LIST_SITE_INTEGRATIONS_FAIL',

  GET_INTEGRATION_CONNECTIONS_REQUEST = '@integrations/GET_INTEGRATION_CONNECTIONS_REQUEST',
  GET_INTEGRATION_CONNECTIONS_SUCCESS = '@integrations/GET_INTEGRATION_CONNECTIONS_SUCCESS',
  GET_INTEGRATION_CONNECTIONS_FAIL = '@integrations/GET_INTEGRATION_CONNECTIONS_FAIL',

  GET_OAUTH_URL_REQUEST = '@integrations/GET_OAUTH_URL_REQUEST',
  GET_OAUTH_URL_SUCCESS = '@integrations/GET_OAUTH_URL_SUCCESS',
  GET_OAUTH_URL_FAIL = '@integrations/GET_OAUTH_URL_FAIL',

  CONNECT_INTEGRATION_REQUEST = '@integrations/CONNECT_INTEGRATION_REQUEST',
  CONNECT_INTEGRATION_SUCCESS = '@integrations/CONNECT_INTEGRATION_SUCCESS',
  CONNECT_INTEGRATION_FAIL = '@integrations/CONNECT_INTEGRATION_FAIL',

  DELETE_CONNECTION_REQUEST = '@integrations/DELETE_CONNECTION_REQUEST',
  DELETE_CONNECTION_SUCCESS = '@integrations/DELETE_CONNECTION_SUCCESS',
  DELETE_CONNECTION_FAIL = '@integrations/DELETE_CONNECTION_FAIL',
}
